import { defineSlotRecipe } from '@chakra-ui/react';
// import { system } from '../../ui/theme';

export const headerRecipe = defineSlotRecipe({
  // export const headerRecipe = system.sva({
  className: 'ac-header',
  slots: ['root', 'logoContainer', 'logo', 'logoLink', 'group', 'groupContainer'],
  base: {
    root: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'stretch',

      padding: '0 1rem 0 0',
      backgroundColor: 'bg',
      borderBottom: 'primary',
      height: 'header.height',

      overflow: 'hidden',
    },
    logoContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',

      marginLeft: '30px',
    },
    logo: {
      display: 'flex',
      flexDir: 'row',
      alignItems: 'center',
      gap: '26px',

      fontFamily: 'workSans',
    },

    logoLink: {
      borderRadius: 'smaller',
      backgroundColor: 'grey.light.0',

      display: 'flex',
      flexDirection: 'row',
      gap: '12px',
      justifyContent: 'space-between',
      alignItems: 'center',

      fontFamily: 'workSans',

      fontSize: '22px',
      letterSpacing: '0.9px',
      lineHeight: '16px',
      fontWeight: 800,
      color: 'halton.blue',
      cursor: 'pointer',

      height: '40px',
      padding: '20px 15px',

      textDecoration: 'none',
      _visited: {
        // color: 'grey.dark.2',
        color: 'halton.blue',
      },
      _active: {
        // color: 'grey.dark.2',
        color: 'halton.blue',
      },

      transitionProperty: 'backgroundColor, background',
      transitionDuration: 'slow',
      transitionBehavior: 'linear',

      _hover: {
        backgroundColor: 'grey.light.1',
      },

      '& > span': {
        mb: '-5px',
      },
    },
    groupContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      flexDirection: 'row',
      alignItems: 'stretch',
      // height: 'header.height',

      '& > *:not(:first-child)': {
        borderLeft: 'subtle',
      },
    },
    group: {
      padding: '0 20px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: '1rem',
      // height: 'header.height',
    },
  },
});
